/** Google OAuth web client ID. Override with REACT_APP_GOOGLE_CLIENT_ID. */
export function getGoogleClientId() {
  const fromEnv = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
  if (fromEnv && !fromEnv.startsWith('disabled')) {
    return fromEnv;
  }
  // platforms-dev OAuth web client (add UI origins in Google Console).
  return '464634824300-djgbk00khdtem528ur3pu5ldapeh9h3r.apps.googleusercontent.com';
}

export function hasGoogleClientId() {
  const id = getGoogleClientId();
  return Boolean(id && id.includes('.apps.googleusercontent.com'));
}
